import type React from 'react';
import { useState, useEffect, useCallback } from 'react';

interface EorzeaClockProps {
  useLT?: boolean;
  useST?: boolean;
}

export const EorzeaClock: React.FC<EorzeaClockProps> = ({ useLT, useST }) => {
  const [lt, setLt] = useState<string>('--:--');
  const [st, setSt] = useState<string>('--:--');
  const [et, setEt] = useState<string>('--:--');

  const formatTimestamp = useCallback(
    (timestamp: number = Date.now()): string => {
      const time = (timestamp / 60 / 1000) % 1440;
      const h = Math.floor(time / 60)
        .toFixed(0)
        .padStart(2, '0');
      const m = Math.floor(time % 60)
        .toFixed(0)
        .padStart(2, '0');
      return `${h}:${m}`;
    },
    [],
  );

  const getLocalTime = useCallback((): string => {
    const ts = Date.now() - new Date().getTimezoneOffset() * 60 * 1000;
    return formatTimestamp(ts);
  }, [formatTimestamp]);

  const getServerTime = useCallback((): string => {
    return formatTimestamp();
  }, [formatTimestamp]);

  const getEorzeaTime = useCallback((): string => {
    return formatTimestamp((Date.now() * 3600) / 175);
  }, [formatTimestamp]);

  useEffect(() => {
    const timerID = setInterval(() => {
      setLt(getLocalTime());
      setSt(getServerTime());
      setEt(getEorzeaTime());
    }, 1000 / 12);

    return () => {
      clearInterval(timerID);
    };
  }, [getLocalTime, getServerTime, getEorzeaTime]);

  return (
    <span className='eorzea-clock'>
      {useLT && <span className='eorzea-clock__lt'>&#xe0d0; {lt}</span>}

      {useST && <span className='eorzea-clock__st'>&#xe0d1; {st}</span>}

      <span className='eorzea-clock__et'>&#xe0d2; {et}</span>
    </span>
  );
};
